import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

// Lazy-loaded views
const Home = () => import('../components/HomePage.vue');
const WriteLetter = () => import('../components/WriteLetter.vue');
const MyLetters = () => import('../components/MyLetters.vue');
const About = () => import('../components/AboutPage.vue');
const PrivacyPolicy = () => import('../components/PrivacyPolicy.vue');
const TermsOfService = () => import('../components/TermsOfService.vue');

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/write',
        name: 'WriteLetter',
        component: WriteLetter,
        meta: { requiresAuth: true },
    },
    {
        path: '/my-letters',
        name: 'MyLetters',
        component: MyLetters,
        meta: { requiresAuth: true },
    },
    {
        path: '/about',
        name: 'About',
        component: About,
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: PrivacyPolicy,
    },
    {
        path: '/terms',
        name: 'Terms',
        component: TermsOfService,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Navigation guard for auth
router.beforeEach(async (to, from, next) => {
    // Wait for auth to initialize
    if (store.state.authLoading) {
        await store.dispatch('initAuth');
    }

    if (to.meta.requiresAuth && !store.getters.isLoggedIn) {
        // Redirect to home if not authenticated
        next({ name: 'Home', query: { redirect: to.fullPath } });
    } else {
        next();
    }
});

export default router;
